var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_153798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5619 8.31195H9.68806V1.43807C9.68806 1.06047 9.37928 0.750008 9 0.750008C8.62241 0.750008 8.31195 1.0588 8.31195 1.43807V8.31195H1.43807C1.06047 8.31195 0.750008 8.62073 0.750008 9C0.750008 9.3776 1.0588 9.68806 1.43807 9.68806H8.31195V16.5619C8.31195 16.9395 8.62073 17.25 9 17.25C9.3776 17.25 9.68806 16.9412 9.68806 16.5619V9.68806H16.5619C16.9395 9.68806 17.25 9.37928 17.25 9C17.2483 8.62241 16.9395 8.31195 16.5619 8.31195Z",
    fill: "#2469EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_153798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.80482dbf5bb7538738f060a690be74ff.svg";
export { ForwardRef as ReactComponent };